export default function Modal() {
  return <>{/* This is PageContent-Modal component */}</>;
}
